import { LogoMode } from '@dp/components/logo/logo.component';
import { environment } from 'environments/environment';

const CDN_BASE_URL = environment.cdnAssetsBasePath;

//uds_icon
export const UDS_ICON_MAP = {
  HeaderUser: `${CDN_BASE_URL}uds_icons/share_person.ods.svg`,
  helpCenter: `${CDN_BASE_URL}uds_icons/helpCenter.ods.svg`,
  notification: `${CDN_BASE_URL}uds_icons/notification.ods.svg`,
  notificationFilled: `${CDN_BASE_URL}uds_icons/notificationFilled.ods.svg`,
  faq: `${CDN_BASE_URL}uds_icons/faq.ods.svg`,
  invoices: `${CDN_BASE_URL}uds_icons/invoices.ods.svg`,
  advanceConsent: `${CDN_BASE_URL}uds_icons/advance-consent.ods.svg`,
  partnersManagement: `${CDN_BASE_URL}uds_icons/partners_management.ods.svg`,
  logout: `${CDN_BASE_URL}uds_icons/logout.ods.svg`,
  manage_users: `${CDN_BASE_URL}uds_icons/manage_users.ods.svg`,
  user_settings: `${CDN_BASE_URL}uds_icons/user_settings.ods.svg`,
  company_settings: `${CDN_BASE_URL}uds_icons/company-settings.ods.svg`,
  support: `${CDN_BASE_URL}uds_icons/online_chat.ods.svg`,
  contact: `${CDN_BASE_URL}uds_icons/contact.ods.svg`,
  tutorial: `${CDN_BASE_URL}uds_icons/tutorial.ods.svg`,
  info: `${CDN_BASE_URL}uds_icons/helpCenter.ods.svg`,
  infoIcon: `${CDN_BASE_URL}uds_icons/info-exclamation.ods.svg`,
  addTag: `${CDN_BASE_URL}uds_icons/add-1.ods.svg`,
  flag: `${CDN_BASE_URL}uds_icons/flag-b.ods.svg`,
  flagFilled: `${CDN_BASE_URL}uds_icons/flagFilled.ods.svg`,
  share_person: `${CDN_BASE_URL}uds_icons/share_person.ods.svg`,
  document: `${CDN_BASE_URL}uds_icons/document.ods.svg`,
  note: `${CDN_BASE_URL}uds_icons/note.ods.svg`,
  product: `${CDN_BASE_URL}uds_icons/orders.ods.svg`,
  productMaster: `${CDN_BASE_URL}uds_icons/product_master.ods.svg`,
  report: `${CDN_BASE_URL}uds_icons/report.ods.svg`,
  exception: `${CDN_BASE_URL}uds_icons/report.ods.svg`,
  exceptionWarning: `${CDN_BASE_URL}uds_icons/report.ods.svg`,
  exceptionIcon: `${CDN_BASE_URL}uds_icons/report.ods.svg`,
  exceptionIcon2: `${CDN_BASE_URL}uds_icons/report.ods.svg`,
  pod: `${CDN_BASE_URL}uds_icons/pod.svg`,
  edit: `${CDN_BASE_URL}uds_icons/edit.ods.svg`,
  search: `${CDN_BASE_URL}uds_icons/search.ods.svg`,
  search_blue: `${CDN_BASE_URL}uds_icons/search.ods.svg`,
  export: `${CDN_BASE_URL}uds_icons/download.ods.svg`,
  notFoundContainers: `${CDN_BASE_URL}uds_icons/notFoundContainers.svg`,
  noResultMileStones: `${CDN_BASE_URL}uds_icons/noResultMileStones.png`,
  noResultSchedules: `${CDN_BASE_URL}uds_icons/noResultSchedules.png`,
  noResultExceptions: `${CDN_BASE_URL}uds_icons/noResultExceptions.png`,
  noNotifications: `${CDN_BASE_URL}uds_icons/noNotifications.png`,
  noResultTbgLeft: `${CDN_BASE_URL}uds_icons/noResultTbgLeft.png`,
  noOrderProductsFound: `${CDN_BASE_URL}uds_icons/noOrderProductsFound.png`,
  noOrderShipmentsFound: `${CDN_BASE_URL}uds_icons/noOrderShipmentsFound.png`,
  noCalendarFound: `${CDN_BASE_URL}uds_icons/noCalendarFound.png`,
  noCalendarFoundHR: `${CDN_BASE_URL}uds_icons/noCalendarFoundHighResolution.png`,
  noExceptionsFound: `${CDN_BASE_URL}uds_icons/noCalendarFound.png`,
  noMilestonesFound: `${CDN_BASE_URL}uds_icons/noMilestonesFound.png`,
  oceanOnDashboard: `${CDN_BASE_URL}uds_icons/oceanOnDashboard.png`,
  airOnDashboard: `${CDN_BASE_URL}uds_icons/airOnDashboard.png`,
  noResultTbg: `${CDN_BASE_URL}uds_icons/noResultTbg.png`,
  noExceptions: `${CDN_BASE_URL}uds_icons/noExceptions.ods.svg`,
  noResultFound: `${CDN_BASE_URL}uds_icons/search.ods.svg`,
  addContainer: `${CDN_BASE_URL}uds_icons/addContainer.ods.svg`,
  history: `${CDN_BASE_URL}uds_icons/predicted_eta.ods.svg`,
  upload: `${CDN_BASE_URL}uds_icons/upload.ods.svg`,
  open_eye: `${CDN_BASE_URL}uds_icons/open_eye.ods.svg`,
  open_eye_gray: `${CDN_BASE_URL}uds_icons/closed_eye.ods.svg`,
  filter: `${CDN_BASE_URL}uds_icons/filter.ods.svg`,
  filter1: `${CDN_BASE_URL}uds_icons/filter.ods.svg`,
  filterActive: `${CDN_BASE_URL}uds_icons/filter.ods.svg`,
  delete: `${CDN_BASE_URL}uds_icons/delete.ods.svg`,
  complete: `${CDN_BASE_URL}uds_icons/complete.ods.svg`,
  inComplete: `${CDN_BASE_URL}uds_icons/inComplete.ods.svg`,
  shareLink: `${CDN_BASE_URL}uds_icons/link.ods.svg`,
  arrowDown: `${CDN_BASE_URL}uds_icons/arrowDown.ods.svg`,
  arrowUp: `${CDN_BASE_URL}uds_icons/arrowUp.ods.svg`,
  airFreight: `${CDN_BASE_URL}uds_icons/air-shipments.ods.svg`,
  uds_delete: `${CDN_BASE_URL}uds_icons/uds_delete.svg`,
  f_tracking: `${CDN_BASE_URL}uds_icons/milestone.ods.svg`,
  f_supplyChain: `${CDN_BASE_URL}uds_icons/f_supplyChain.ods.svg`,
  f_exception: `${CDN_BASE_URL}uds_icons/report.ods.svg`,
  f_insight: `${CDN_BASE_URL}uds_icons/demdetGraph.ods.svg`,
  demurrage_configuration: `${CDN_BASE_URL}uds_icons/demurrage-configuration.ods.svg`,
  airShipment: `${CDN_BASE_URL}uds_icons/air-shipments.ods.svg`,
  olShipment: `${CDN_BASE_URL}uds_icons/product_master.ods.svg`,
  roadShipment: `${CDN_BASE_URL}uds_icons/road-1.ods.svg`,
  flight: `${CDN_BASE_URL}uds_icons/air-shipments.ods.svg`,
  vessel: `${CDN_BASE_URL}uds_icons/vessel.ods.svg`,
  co2: `${CDN_BASE_URL}uds_icons/co2.ods.svg`,
  blueTick: `${CDN_BASE_URL}uds_icons/complete.ods.svg`,
  whiteTick: `${CDN_BASE_URL}uds_icons/whiteTickIcon.ods.svg`,
  closeIcon: `${CDN_BASE_URL}uds_icons/close-icon.ods.svg`,
  closeIcon2: `${CDN_BASE_URL}uds_icons/close-icon.ods.svg`,
  dragIcon: `${CDN_BASE_URL}uds_icons/drag.ods.svg`,
  shipments: `${CDN_BASE_URL}svg/on_water.ods.svg`,
  air_shipments: `${CDN_BASE_URL}uds_icons/air-shipments.ods.svg`,
  truck: `${CDN_BASE_URL}uds_icons/road-1.ods.svg`,
  expand: `${CDN_BASE_URL}uds_icons/expand.ods.svg`,
  expandRev: `${CDN_BASE_URL}uds_icons/expand-rev.ods.svg`,
  predictedEta: `${CDN_BASE_URL}uds_icons/predicted_eta.ods.svg`,
  arrivingPredictedEta: `${CDN_BASE_URL}uds_icons/predicted_eta.ods.svg`,
  infoExclamation: `${CDN_BASE_URL}uds_icons/info-exclamation.ods.svg`,
  carouselLeft: `${CDN_BASE_URL}uds_icons/carousel-left.svg`,
  carouselRight: `${CDN_BASE_URL}uds_icons/carousel-right.svg`,
  closeIconFilter: `${CDN_BASE_URL}uds_icons/close-icon.ods.svg`,
  demdetGraph: `${CDN_BASE_URL}uds_icons/demdetGraph.svg`,
  demdetTable: `${CDN_BASE_URL}uds_icons/demdetTable.svg`,
  config_icon: `${CDN_BASE_URL}uds_icons/config_icon.ods.svg`,
  graph_loader: `${CDN_BASE_URL}uds_icons/graph_loader.ods.svg`,
  no_graph_data: `${CDN_BASE_URL}uds_icons/no_graph_data.svg`,
  customisation_icon: `${CDN_BASE_URL}uds_icons/customisation_icon.svg`,
  port_vessel_change: `${CDN_BASE_URL}uds_icons/port_vessel_change.svg`,
  checkConsentStatus: `${CDN_BASE_URL}uds_icons/advance-consent.ods.svg`,
  vehicleupdate: `${CDN_BASE_URL}uds_icons/road-1.ods.svg`,
  vehiclenotupdate: `${CDN_BASE_URL}uds_icons/vehiclenotupdate.ods.svg`,
  warningvehicle: `${CDN_BASE_URL}uds_icons/report.ods.svg`,
  milestone: `${CDN_BASE_URL}uds_icons/milestone.ods.svg`,
  time: `${CDN_BASE_URL}uds_icons/time.ods.svg`,
  user_1: `${CDN_BASE_URL}uds_icons/user-1.ods.svg`,
  user_3: `${CDN_BASE_URL}uds_icons/user-3.ods.svg`,
  noNewsResult: `${CDN_BASE_URL}uds_icons/no_news_result.svg`,
  interModalJourney: `${CDN_BASE_URL}uds_icons/intermodal-journey.svg`,
  locations2: `${CDN_BASE_URL}uds_icons/locations.ods.svg`,
  chatbotIcon: `${CDN_BASE_URL}uds_icons/note.ods.svg`,
  addShipment: `${CDN_BASE_URL}uds_icons/add-1.ods.svg`,
  dashboard: `${CDN_BASE_URL}uds_icons/dashboard-1.ods.svg`,
  orders: `${CDN_BASE_URL}uds_icons/orders.ods.svg`,
  storage_cost_icon: `${CDN_BASE_URL}uds_icons/storage_cost.ods.svg`,
  shipment: `${CDN_BASE_URL}uds_icons/multipleMode.ods.svg`,
  calendar_nav: `${CDN_BASE_URL}uds_icons/schedules.ods.svg`,
  analytics_nav: `${CDN_BASE_URL}uds_icons/analytics-nav.ods.svg`,
  schedules: `${CDN_BASE_URL}uds_icons/schedulesParent.ods.svg`,
  outsourced_logistics: `${CDN_BASE_URL}uds_icons/product_master.ods.svg`,
  configurePrioritisation: `${CDN_BASE_URL}uds_icons/configure-prioritisation.ods.svg`,
  trips_icon: `${CDN_BASE_URL}uds_icons/trips.ods.svg`,
  stop_icon: `${CDN_BASE_URL}uds_icons/stop.ods.svg`,
  orders_icon: `${CDN_BASE_URL}uds_icons/order-2.ods.svg`,
  parent_orders_icon: `${CDN_BASE_URL}uds_icons/parent_orders.ods.svg`,
  integration_issues_icon: `${CDN_BASE_URL}uds_icons/integration_issues.ods.svg`,
  exceptions_icon: `${CDN_BASE_URL}uds_icons/exceptions.ods.svg`,
};

//images
export const IMAGES_MAP = {
  cargoFlowNewSquare: `${CDN_BASE_URL}cargoflow-new-square.svg`,
  cargoFlowNew: `${CDN_BASE_URL}cargoflow-new.svg`,
  container_delivery: `${CDN_BASE_URL}images/svg/side-nav/dashboard/ContainerDelivery-2.svg`,
};

export const getCorpLogo = (orgCode, logoMode) => {
  const assetsLogo = ['abinbev', 'canadiantire', 'democustomer', 'hondacom', 'nestleuae', 'turktraktor'];
  if (assetsLogo.indexOf(orgCode) > -1) {
    let corp_logo = `${CDN_BASE_URL}images/corp_logos/${orgCode}`;
    switch (logoMode) {
      case LogoMode.compact:
        corp_logo = corp_logo + `_sqaure.png`;
        break;
      case LogoMode.wide:
        corp_logo = corp_logo + `_long.png`;
        break;
      case LogoMode.full:
        corp_logo = corp_logo + `_full.png`;
        break;
      default:
        break;
    }
    return corp_logo;
  } else {
    return `${CDN_BASE_URL}cargoflow-new.svg`;
  }
};

export const getUdsIconKey = (iconKey: string): string => {
  switch (iconKey) {
    case 'DASHBOARD_ICON':
      return 'dashboard';
    case 'CONTAINER_ICON':
      return 'shipment';
    case 'SHIP_ICON':
      return 'shipments';
    case 'FLIGHT_ICON':
      return 'air_shipments';
  }
  return iconKey.toLowerCase();
}
